import type { RuleHandler } from "../types";
import { setIncludes } from "utilities/promotions/setIncludes";

const checkExcludedTournamentIds: RuleHandler = (context, requirement) => {
  const requirementAttributes = requirement.userDrivenAttributes;

  return !setIncludes(
    new Set(requirementAttributes?.excludedTournamentIds),
    new Set(context.selection.tournamentIds),
  );
};

export { checkExcludedTournamentIds };
